import classNames from 'clsx';
import { ReactComponent as AppGalleryLogo } from 'img/banner-mobile/appGalleryMobile.svg';
import { ReactComponent as AppStoreLogo } from 'img/banner-mobile/appStoreMobile.svg';
import { ReactComponent as GooglePlayLogo } from 'img/banner-mobile/googlePlayMobile.svg';
import { ReactComponent as RuStoreLogo } from 'img/banner-mobile/ruStoreMobile.svg';
import { ReactComponent as FourSixStars } from 'img/nestleLanding/FourHalf.svg';
import { ReactComponent as StarsFive } from 'img/nestleLanding/starsFive.svg';
import React from 'react';
import { useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';

import styles from './RatingWithApplications.css';

export const RatingWithApplications = () => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    return (
        <div
            className={classNames(styles.root, {
                [styles.rootMobile]: isMobile,
            })}
        >
            <div className={styles.item}>
                <a href="https://apps.rustore.ru/app/ru.mail.cloud" rel="nofollow">
                    <RuStoreLogo width="158" height="50" />
                </a>
                <a href="https://apps.rustore.ru/app/ru.mail.cloud" rel="nofollow">
                    <span className={styles.value}>4.8</span>
                    <StarsFive width="71" height="14" />
                </a>
            </div>
            <div className={styles.item}>
                <a href="https://trk.mail.ru/c/muv7c7">
                    <AppStoreLogo width="158" height="50" />
                </a>
                <a href="https://trk.mail.ru/c/muv7c7">
                    <span className={styles.value}>4.8</span>
                    <FourSixStars width="71" height="14" />
                </a>
            </div>
            <div className={styles.item}>
                <a href="https://appgallery8.huawei.com/#/app/C101034901" rel="nofollow">
                    <AppGalleryLogo width="158" height="50" />
                </a>
                <a href="https://appgallery8.huawei.com/#/app/C101034901" rel="nofollow">
                    <span className={styles.value}>4.7</span>
                    <StarsFive width="71" height="14" />
                </a>
            </div>
            <div className={styles.item}>
                <a href="https://trk.mail.ru/c/pbnfy7">
                    <GooglePlayLogo width="158" height="50" />
                </a>
                <a href="https://trk.mail.ru/c/pbnfy7">
                    <span className={styles.value}>4.6</span>
                    <FourSixStars width="71" height="14" />
                </a>
            </div>
        </div>
    );
};
